import PropTypes from 'prop-types';
import React, { memo } from 'react';
import _ from 'underscore';

import { PropTypeRichTextItems } from './shapes';
import type {
  EmphasizedTextModel,
  ImageModel,
  LinkModel,
  RichTextModel,
  TextModelProps,
} from './types';

let getRichTextFromArrays: (richTextItems: RichTextModel[], textItems: string[]) => string;

const getLinkHtml = ({
  Uri,
  TextItems,
  RichTextItems
}: LinkModel) => `<a href="${Uri || '#'}" target="popupFrame">${getRichTextFromArrays(RichTextItems || [], TextItems || [])}</a>`;
const getImageHtml = ({
  Uri
}: ImageModel) => `<img src="${Uri}">`;
const getEmHtml = ({
  Class,
  TextValue
}: EmphasizedTextModel) => `<span${Class ? ` class="${Class}"` : ''}>${TextValue}</span>`;

const getRichTextHtml = (val: RichTextModel) => {
  switch (val.Type) {
    case 'LinkModel':
      return getLinkHtml(val);
    case 'ImageModel':
      return getImageHtml(val);
    case 'EmphasizedTextModel':
      return getEmHtml(val);
    case 'VoidModel':
    default:
      return '';
  }
};

getRichTextFromArrays = (richTextItems, textItems) => {
  let richTextContent = '';
  let isPlainTextFragment = true;
  let plainTextIndex = 0;
  let richTextIndex = 0;

  while (plainTextIndex < textItems.length && richTextIndex < richTextItems.length) {
    if (isPlainTextFragment && richTextItems[richTextIndex].Type !== 'VoidModel') {
      richTextContent += _.escape(textItems[plainTextIndex]);
      plainTextIndex += 1;
    } else {
      richTextContent += getRichTextHtml(richTextItems[richTextIndex]);
      richTextIndex += 1;
    }

    isPlainTextFragment = !isPlainTextFragment;
  }

  if (plainTextIndex < textItems.length) {
    richTextContent += _.escape(textItems[plainTextIndex]);
    plainTextIndex += 1;
  } else {
    while (richTextIndex < richTextItems.length) {
      richTextContent += getRichTextHtml(richTextItems[richTextIndex]);
      richTextIndex += 1;
    }
  }

  return richTextContent;
};

const getRichTextWithBase = (richTextItems: RichTextModel[], baseString: string) => _.reduce(
  richTextItems,
  (prevObj: string, val: RichTextModel, key: number) => prevObj.replace(new RegExp(`\\{${key}}`, 'g'), getRichTextHtml(val)),
  _.escape(baseString)
);

const TextModelUnwrapped = ({
  i18n,
  localizationKey,
  richTextItems
}: TextModelProps) =>
  // eslint-disable-next-line react/no-danger
  <span dangerouslySetInnerHTML={{ __html: getRichTextWithBase(richTextItems, i18n.getString(localizationKey)) }} />;

TextModelUnwrapped.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  localizationKey: PropTypes.string.isRequired,
  richTextItems: PropTypeRichTextItems.isRequired,
};
TextModelUnwrapped.displayName = 'TextModel';

export default memo(TextModelUnwrapped);
